import { zfUtils } from "./zf_utils";
export class zfcnc {
    static init() {
        $(".zfcnc-module").each(function (item) {
            var divWidth = $(this).innerWidth();
            $(this).css("font-size", divWidth / 15 + "px");
        });
    }
}
zfUtils.onReady(zfcnc.init);
